"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allLoans = allLoans;
exports.loan = loan;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _util = require("@polkadot/api-derive/util");

var _utils = require("../utils");

/**
 * @name loan
 * @description get user loan information includes debit value and collateral value
 * @param {(AccountId | string)} account
 * @param {(CurrencyId | string)} currency
 */
function loan(instanceId, api) {
  return (0, _util.memo)(instanceId, (account, currency) => api.query.loans.positions(currency, account).pipe((0, _operators.map)(result => {
    const {
      debit,
      collateral
    } = result;
    return {
      account,
      currency,
      debit,
      collateral
    };
  })));
}
/**
 * @name allLoans
 * @description get all user loans information includes debit value and collateral value
 * @param {(AccountId | string)} account
 */


function allLoans(instanceId, api) {
  return (0, _util.memo)(instanceId, account => {
    const collateralCurrencyIds = (0, _utils.getAllCollateralCurrencyIds)(api);
    const loanQuery = loan(instanceId, api);
    return (0, _rxjs.combineLatest)(collateralCurrencyIds.map(currency => loanQuery(account, currency)));
  });
}